import React from 'react';
import { Modal } from 'hyperdb-utils';
import { AppLink } from '../../../routing/containers';

const ModalReservationInfo = ({ currentUser, reservation, onClose }) => {
  return (
    <Modal title="Reservation info" onClose={ onClose } labelCancel="Close">
      <div className="row info-reservation">
        <div className="pull-left labels">
          <h5>origin</h5>
          <h5>reference</h5>
          <h5>property</h5>
          <h5>customer</h5>
          <h5>arrival date</h5>
          <h5>departure date</h5>
          <h5>status</h5>
        </div>
        <div>
          <h5>{ reservation.origin }</h5>
          <h5>
            {
              ['admin', 'manager'].includes(currentUser.group.name)
                ? <AppLink to={ `/daily-rental/reservations/${reservation.id}` }>{ reservation.reference }</AppLink>
                : reservation.reference
            }
          </h5>
          <h5>{ reservation.property.name }</h5>
          <h5>{ reservation.customer.name }</h5>
          <h5>{ reservation.arrival_date }</h5>
          <h5>{ reservation.departure_date }</h5>
          <h5>{ reservation.status }</h5>
        </div>
      </div>
    </Modal>
  );
};

export default ModalReservationInfo;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/availabilities/components/ModalReservationInfo.jsx